import { EXTEND } from '../../../../types/Campaigns';
import useAuth from '../../../app/src/features/authentication/hooks/useAuth';
import { CampaignTemplate } from '../../../campaigns/src/types/campaignTypes';

const useCampaignsOutputUrl = (): string | undefined => {
  const { campaign } = useAuth();

  if (campaign) {
    if (campaign.template) {
      if (
        campaign.template?.key === CampaignTemplate.PRICE_COMPARISON ||
        campaign.show_offers
      ) {
        return '/product/session/offers';
      }
      return '/product/session/finalize';
    }

    if (campaign.extend === EXTEND.LEAD || !campaign.extend) {
      return '/product/session/finalize';
    } else if (
      campaign.extend === EXTEND.INTERNAL_OFFER ||
      campaign.extend === EXTEND.EXTERNAL_OFFER
    ) {
      return '/product/session/offers';
    }
  }

  return undefined;
};

export default useCampaignsOutputUrl;
